import { createSlice } from '@reduxjs/toolkit';
import { createBulkFabricMO, createMoOrder, downloadBulkCreateSample, getMoOrders } from './api';

export const FabricMoSlice = createSlice({
    name: 'fabricMoSlice',
    initialState: {
        isLoading: false,
        data: {},
        error: '',
        createFabricMOSuccessMessage: '',
        createBulkFabricMOSuccessMessage: '',
        downloadBulkFabricMOSuccessMessage: '',
    },

    reducers: {
      clear: (state, action) => {
        if(action?.payload?.key) {
          return {
            ...state,
            [action.payload.key]: action.payload.value
          }
        }
        return { ...state }
      },
      clearErrorState: (state, action) => {
        return {
          ...state,
          error: action.payload
        }
      }
    },

    extraReducers: (builder) => {
      builder.addCase(getMoOrders.pending, (state, action) => {
          state.isLoading = true;
      })
      builder.addCase(getMoOrders.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.data = action.payload.data;
          state.tabsData = action.payload.data?.quantity_map;
      })
      builder.addCase(getMoOrders.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(createMoOrder.pending, (state, action) => {
          state.isLoading = true;
      })
      builder.addCase(createMoOrder.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.createFabricMOSuccessMessage = action.payload.data.message;
      })
      builder.addCase(createMoOrder.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(createBulkFabricMO.pending, (state, action) => {
          state.isLoading = true;
      })
      builder.addCase(createBulkFabricMO.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.createBulkFabricMOSuccessMessage = action.payload.data.message;
      })
      builder.addCase(createBulkFabricMO.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(downloadBulkCreateSample.pending, (state, action) => {
          state.isLoading = true;
      })
      builder.addCase(downloadBulkCreateSample.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.downloadBulkFabricMOSuccessMessage = 'Successfully downloaded file';
      })
      builder.addCase(downloadBulkCreateSample.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      
      
    }
})

export const { clearGatePassDetailsData, clearErrorState, clear } = FabricMoSlice.actions

export default FabricMoSlice.reducer